import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { h4 } from '@helpers/typography';
import { imageCoverContainer } from '@helpers/image';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.article) `
  display: grid;
  grid-area: 1 / 1;
  color: ${brand.white};
`;
const ImageWrapper = styled(m.div) `
  position: relative;
  display: block;
  grid-area: 1 / 1;
  user-select: none;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, var(--tintAmount));
    width: 100%;
  }
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer(true)}
`;
const ContentWrapper = styled(m.div) `
  display: flex;
  align-items: flex-end;
  grid-area: 1 / 1;
  justify-content: space-between;
  padding: 32px;
  z-index: 2;

  @media ${from(Device.DesktopSmall)} {
    padding: 80px;
    padding-left: 140px;
  }
`;
const Content = styled(m.p) `
  ${h4};

  position: relative;
  display: block;
  flex: 1 1 auto;
  margin: 0;
  margin-right: 16px;
  max-width: 492px;
  padding: 32px 0;
`;
const AccentLine = styled(m.span) `
  content: '';
  position: absolute;
  left: 0;
  display: block;
  background: currentColor;
  height: 4px;
  transform-origin: left center;
  width: 100%;

  &[data-position='top'] {
    top: 0;
    max-width: 96px;
  }

  &[data-position='bottom'] {
    bottom: 0;
  }
`;
const CtaWrapper = styled(m.div) `
  display: block;
  flex: 0 0 auto;
  user-select: none;
`;
const SectionDetailStyles = {
    AccentLine,
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Image,
    ImageWrapper,
};
export default SectionDetailStyles;
